import BeerillionerDashboard from "./beerillioner/BeerillionerDashboardContent";

export default BeerillionerDashboard;
